<template>
    <AuthLayout v-bind="customerSharedData.getAuthLayoutProps()">
        <div
            v-if="emailSent"
            class="text-sm mb-4"
        >
            <Alert
                title="Email sent!"
                type="success"
            >
                We sent you an email with a link that will allow you to setup a
                new password, make sure to look into your spam folder as well.
            </Alert>
        </div>
        <div v-else>
            <ApiForm
                method="POST"
                :url="urlFactory.makeCustomerPasswordResetUrl()"
                ref="apiFormRef"
            >
                <FormControl
                    label="Email"
                    required
                >
                    <TextInput
                        type="email"
                        :name="RequestBodyKeyEnum.Customer_PasswordReset_Email"
                        required
                    />
                </FormControl>
                <Button
                    @click="submit()"
                    :loading="apiFormRef?.loading.valueOf()"
                    iconName="paper-plane"
                    iconClass="w-3.5 h-3.5"
                    class="w-full mt-2"
                >
                    Send Password Reset Email
                </Button>
                <div class="flex flex-col my-2 space-y-1">
                    <div class="text-sm leading-6">
                        <a
                            :href="urlFactory.makeCustomerLoginUrl()"
                            class="font-semibold text-primary hover:text-primary-shade"
                        >
                            Already have a password?
                        </a>
                    </div>
                </div>
                <div
                    v-if="turnstileEnabled"
                    class="mt-4 flex justify-center"
                >
                    <div
                        class="cf-turnstile"
                        :data-sitekey="turnstileSiteKey"
                    ></div>
                </div>
            </ApiForm>
        </div>
    </AuthLayout>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref } from 'vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import Button from '@/Shared/Component/Button.vue'
    import AuthLayout from '@/Shared/Layout/Customer/Auth/AuthLayout.vue'
    import Alert from '@/Shared/Component/Alert.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import Customer from '@/App/Customer/Entity/Customer'
    import CustomerSharedData from '@/Shared/Entity/CustomerSharedData'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    interface ShowCustomerPasswordResetProps {
        customerSharedDataData: CustomerSharedData
        turnstileEnabled: boolean
        turnstileSiteKey: string
    }

    const props = defineProps<ShowCustomerPasswordResetProps>()
    const customerSharedData = CustomerSharedData.hydrate(
        props.customerSharedDataData,
    )
    const emailSent = ref(false)
    const apiFormRef = ref<ApiFormRefType>(null)

    const submit = () => {
        emailSent.value = false

        apiFormRef.value?.submit()?.then(() => {
            emailSent.value = true
        })
    }
    const urlFactory = new UrlFactory()
</script>
